const API_VERSION = 'v1';

export const API_ENDPOINTS = {
  'auth.login': `${API_VERSION}/auth/login`,
  'auth.register': `${API_VERSION}/auth/register`,
  'auth.logout': `${API_VERSION}/auth/logout`,
  'auth.refreshToken': `${API_VERSION}/auth/refresh`,
  'auth.setup': `${API_VERSION}/register/:confirmationCode`,
  'auth.setupComplete': `${API_VERSION}/register/complete`,
  'auth.passwordResetInit': `${API_VERSION}/auth/password-reset/init`,
  'auth.passwordResetComplete': `${API_VERSION}/auth/password-reset/complete`,

  profile: `${API_VERSION}/me`,

  'dashboard.counters': `${API_VERSION}/dashboard/counters`,

  'search.global': `${API_VERSION}/search`,

  'firms.list': `${API_VERSION}/firms`,
  'firms.detail': `${API_VERSION}/firms/:firmId`,

  'users.list': `${API_VERSION}/users`,
  'users.detail': `${API_VERSION}/users/:userId`,
  'users.counters': `${API_VERSION}/users/:userId/counters`,
  'users.resend': `${API_VERSION}/users/:userId/resend`,

  'roles.list': `${API_VERSION}/roles`,

  'matters.list': `${API_VERSION}/matters`,
  'matters.detail': `${API_VERSION}/matters/:matterId`,

  'matters.workflow': `${API_VERSION}/matters/:matterId/workflow`,
  'matters.workflow.step': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId`,
  'matters.workflow.signoffStep': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId/signoff`,
  'matters.workflow.retryStep': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId/retry`,
  'matters.workflow.completePhase': `${API_VERSION}/matters/:matterId/workflow/phases/:phaseId/complete`,
  'matter.workflow.assessmentCoverage': `${API_VERSION}/matters/:matterId/workflow/assessment-coverage`,
  'matters.workflow.confirmAction': `${API_VERSION}/matters/:matterId/workflow/actions/:actionId/confirm`,
  'matters.workflow.selectDocumentForAction': `${API_VERSION}/matters/:matterId/workflow/actions/:actionId/select-document`,
  'matters.workflow.sendCredasChecks': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId/credas-checks`,
  'matters.workflow.selectVerificationMethod': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId/verification-method`,
  'matters.workflow.documentAiReview': `${API_VERSION}/matters/:matterId/workflow/steps/:stepId/document-ai-review`,
  'matters.workflow.markChecklistItem': `${API_VERSION}/matters/:matterId/checklist/items/:checklistItemId`,

  'matters.credas.journeys': `${API_VERSION}/matters/credas/journeys`,

  'matter.risks': `${API_VERSION}/matters/:matterId/risks`,
  'matter.risks.summary': `${API_VERSION}/matters/:matterId/risks/summary`,
  'matter.risks.phases': `${API_VERSION}/matters/:matterId/risks/phases`,
  'matter.risk.confirm': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/confirm`,
  'matter.risk.reject': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/reject`,
  'matter.risk.severity': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/severity`,
  'matter.risk.markResolved': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/mark-resolved`,
  'matter.risk.notes': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/notes`,
  'matter.risk.activities': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/activities`,
  'matter.risk.markCandidates': `${API_VERSION}/matters/:matterId/risks/:matterRiskId/mark-candidates`,

  'matters.report': `${API_VERSION}/matters/:matterId/report`,
  'matters.property': `${API_VERSION}/matters/:matterId/property`,
  'matters.statistics': `${API_VERSION}/matters/:matterId/statistics`,

  'matter.documents.list': `${API_VERSION}/matters/:matterId/documents`,
  'matter.documents.detail': `${API_VERSION}/matters/:matterId/documents/:documentId`,
  'matter.documents.confirmType': `${API_VERSION}/matters/:matterId/documents/:documentId/type-confirm`,

  'matter.contacts.list': `${API_VERSION}/matters/:matterId/contacts`,
  'matter.contacts.detail': `${API_VERSION}/matters/:matterId/contacts/:contactId`,

  'documents.list': `${API_VERSION}/matters/documents`,
  'documents.detail': `${API_VERSION}/matters/documents/:documentId`,
  'documents.confirmType': `${API_VERSION}/matters/documents/:documentId/type-confirm`,
  'documents.download': `${API_VERSION}/matters/documents/:documentId/download`,

  'risk.list': `${API_VERSION}/matters/risks`,
  'risk.summary': `${API_VERSION}/matters/risks/summary`,
  'risk.categories': `${API_VERSION}/matters/risks/summary`,
  'risk.markCandidates': `${API_VERSION}/matters/risks/:matterRiskId/mark-candidates`,

  'broadcasting.auth': `broadcasting/auth`,

  'aiChats.list': `${API_VERSION}/ai-chats`,
  'aiChats.detail': `${API_VERSION}/ai-chats/:chatId`,
  'aiChats.create': `${API_VERSION}/ai-chats/new`,
  'aiChat.prompt': `${API_VERSION}/ai-chats/:chatId/prompt`,
  'aiChat.messages.list': `${API_VERSION}/ai-chats/:chatId/messages`,
  'aiRun.detail': `${API_VERSION}/ai-chats/runs/:runId`,

  'aiDailyBrief.detail': `${API_VERSION}/ai-daily-brief`,
  'aiDailyBrief.generate': `${API_VERSION}/ai-daily-brief/generate`,

  'notifications.list': `${API_VERSION}/me/notifications`,
  'notifications.unreadCount': `${API_VERSION}/me/notifications/unread-count`,
  'notifications.readAll': `${API_VERSION}/me/notifications/read-all`,
  'notifications.read': `${API_VERSION}/me/notifications/:notificationId/read`,
  'notifications.settings': `${API_VERSION}/me/notification-settings`,
} as const;
